import React, { ReactElement } from 'react'
import { Card } from 'ktr-materialui-react';
import { makeStyles, Grid } from '@material-ui/core';
import { Route, useRouteMatch, Switch } from 'react-router-dom';
import ExternalClampingset from './Assistant/ExternalClampingset';
import InternalClampingset from './Assistant/InternalClampingset';
import ShaftCouplings from './Assistant/ShaftCouplings';
import { useIntl } from 'react-intl';
import ExternalIMG from '../images/Aussenspannelemente.jpg';
import InternalIMG from '../images/Innenspannelemente_preview_6274676196.jpg';
import KTR700IMG from '../images/KTR700.jpg';


const useStyle = makeStyles({
  cardLeft: {
    marginRight: "20px",
    width: "240px",
    height: "350px",
    marginTop: "10px"
  },
  cardRight: {
    marginLeft: "20px",
  },
  heading: {

  },
  card: {
    width: "240px",
    height: "350px"
  }
});

export default function Assistant(): ReactElement {
  const classes = useStyle();
  let { path, url } = useRouteMatch();
  const { formatMessage: f } = useIntl();

  function openLink(url: string) {
    const link = document.createElement('a');
    link.target = '_self';
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  return (
    //app.btn.start
    //buttonText={f({id:'app.btn.start'})}
    <React.Fragment>
      <h2>{f({id:'app.assistant.heading2'})}</h2>
      <Grid container style={{ marginTop: "20px" }} justify="center">
        <Grid item>
          <Card 
            className={`${classes.cardLeft} ${classes.card}`}
            heading={f({id:'app.internal.sing'})} //"Innenspannsatz"
            content={f({id:'app.internal.text'})}
            buttonText={f({id:'app.btn.forward'})}
            imageURL={InternalIMG}
            onClick={(event) => openLink("#" + url + "/internal")}
          />
        </Grid>

        <Grid item >
          <Card heading={f({id:'app.external.sing'})}
            content={f({id:'app.external.text'})}
            className={classes.cardLeft}
            buttonText={f({id:'app.btn.forward'})}
            imageURL={ExternalIMG}
            onClick={(event) => openLink("#" + url + "/external")}
          />
        </Grid>

        <Grid item >
          <Card 
          className={`${classes.cardLeft} ${classes.card}`}
            heading={f({id:'app.shaftcouplings'})}
            content={f({id:'app.shaftcoupling.text'})}
            buttonText={f({id:'app.btn.forward'})}
            imageURL={KTR700IMG}
            onClick={(event) => openLink("#" + url + "/shaft")}
          />
        </Grid>
      </Grid>
      
      <Switch>
        <Route path={`${path}/external`} component={ExternalClampingset}></Route>
        <Route path={`${path}/internal`} component={InternalClampingset}></Route>
        <Route path={`${path}/shaft`} component={ShaftCouplings}></Route>
      </Switch>
    </React.Fragment>
  )
}
